import { Subject } from "@scrile/api-provider/dist/api/SubjectProvider";
import { VaultFile, VaultFileUsageSubjectTypeEnum } from "@scrile/api-provider/dist/api/VaultsProvider";

export enum SortType {
  LAST_USE_TIME_DESC = "LAST_USE_TIME,DESC",
  LAST_USE_TIME = "LAST_USE_TIME",
}

export enum FilterName {
  ALL = "ALL",
  UNUSED = "UNUSED",
}

export type UsedFilesMap = Record<VaultFile["uuid"], boolean>;

export type ThreadSubject = Subject<VaultFileUsageSubjectTypeEnum.MESSAGE_THREAD>;

export type PostSubject = Subject<VaultFileUsageSubjectTypeEnum.USER_CONTENT_SETS>;

export type FilterSubject = ThreadSubject | PostSubject;
